"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GeminiSidePanelSk", {
    enumerable: true,
    get: function() {
        return GeminiSidePanelSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _live = require("lit/directives/live.js");
require("../../../elements-sk/modules/icons/close-icon-sk");
require("../../../elements-sk/modules/icons/send-icon-sk");
require("../../../elements-sk/modules/spinner-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _GeminiSidePanelSk;
let GeminiSidePanelSk = (_GeminiSidePanelSk = class GeminiSidePanelSk extends _lit.LitElement {
    toggle() {
        this.open = !this.open;
    }
    onInput(e) {
        this.input = e.target.value;
    }
    async send() {
        if (!this.input.trim()) return;
        const userMsg = this.input;
        this.messages = [
            ...this.messages,
            {
                role: 'user',
                text: userMsg
            }
        ];
        this.input = '';
        this.isLoading = true;
        try {
            const response = await fetch('/_/chat', {
                method: 'POST',
                body: JSON.stringify({
                    query: userMsg
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const json = await response.json();
                this.messages = [
                    ...this.messages,
                    {
                        role: 'model',
                        text: json.response || 'No response'
                    }
                ];
            } else {
                this.messages = [
                    ...this.messages,
                    {
                        role: 'model',
                        text: 'Error: ' + response.statusText
                    }
                ];
            }
        } catch (_e) {
            this.messages = [
                ...this.messages,
                {
                    role: 'model',
                    text: 'Error sending message.'
                }
            ];
        } finally{
            this.isLoading = false;
        }
    }
    render() {
        return (0, _lit.html)`
      <header>
        <h3>Gemini Assistant</h3>
        <close-icon-sk
          @click=${this.toggle}
          aria-label="Close panel"
          role="button"
          tabindex="0"></close-icon-sk>
      </header>
      <div id="chat-history" role="log" aria-live="polite">
        ${this.messages.map((msg)=>(0, _lit.html)`<div class="message ${msg.role}">${msg.text}</div>`)}
        ${this.isLoading ? (0, _lit.html)`<spinner-sk></spinner-sk>` : ''}
      </div>
      <footer>
        <input
          type="text"
          .value=${(0, _live.live)(this.input)}
          @input=${this.onInput}
          @keydown=${async (e)=>{
            if (e.key === 'Enter') {
                await this.send();
            }
        }}
          placeholder="Ask something..."
          aria-label="Chat input" />
        <send-icon-sk
          @click=${this.send}
          aria-label="Send message"
          role="button"
          tabindex="0"></send-icon-sk>
      </footer>
    `;
    }
    constructor(...args){
        super(...args);
        this.messages = [];
        this.isLoading = false;
        this.input = '';
        this.open = false;
    }
}, (()=>{
    _GeminiSidePanelSk.styles = (0, _lit.css)`
    :host {
      position: fixed;
      top: 0;
      right: -400px;
      width: 400px;
      height: 100%;
      background: var(--background-color, white);
      box-shadow: -2px 0 5px rgb(0 0 0 / 20%);
      transition: right 0.3s ease-in-out;
      z-index: 1000;
      display: flex;
      flex-direction: column;
    }

    :host([open]) {
      right: 0;
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      background: var(--primary-color, #1976d2);
      color: white;
    }

    #chat-history {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .message {
      padding: 8px 12px;
      border-radius: 8px;
      max-width: 80%;
      overflow-wrap: break-word;
    }

    .user {
      align-self: flex-end;
      background: #e3f2fd;
      color: black;
    }

    .model {
      align-self: flex-start;
      background: #f5f5f5;
      color: black;
    }

    footer {
      padding: 16px;
      display: flex;
      gap: 8px;
      border-top: 1px solid #ddd;
    }

    input {
      flex: 1;
      padding: 8px;
    }

    close-icon-sk,
    send-icon-sk {
      cursor: pointer;
      fill: currentcolor;
    }
  `;
})(), _GeminiSidePanelSk);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], GeminiSidePanelSk.prototype, "messages", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], GeminiSidePanelSk.prototype, "isLoading", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], GeminiSidePanelSk.prototype, "input", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        reflect: true
    }),
    _ts_metadata("design:type", Boolean)
], GeminiSidePanelSk.prototype, "open", void 0);
GeminiSidePanelSk = _ts_decorate([
    (0, _decorators.customElement)('gemini-side-panel-sk')
], GeminiSidePanelSk);
